import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';

export default function ExportOption(param: any) {
    console.log(param)
    const [openFirst, setOpenFirst] = useState(false);
    const [rowCount, setrowCount] = useState(1048575);
    const [fileFormat, setfileFormat] = useState("xlsx");
    let [fileName, setfileName] = useState("");

    useEffect(() => {

        let file_value_name: string = "hello world _";
        file_value_name = param?.fileName ? param.fileName : ""

        const result = file_value_name[file_value_name.length - 1] === "_" ? file_value_name.slice(0, -1) : file_value_name.trim()
        console.log(result)
        fileName = result;
        setfileName(fileName)
    }, []);

    const returnValue = (e: any) => {
        param.onChange({ optSts: e, export: 1, type: "ContractStatus", numRows: rowCount, fileName: fileName, fileFormat: fileFormat })
        setOpenFirst(false)
    }
    return (
        <div className="ws-6">

            <Modal open={param.exportOption} onClose={() => returnValue(2)} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} center classNames={{ overlay: '', modal: 'ws-5 paddingCenterBox bgTransparent' }} >
                <div className="box">

                    <div className="box-header-main well">
                        <h2><i className="fa fa-question-circle"></i> Export Options</h2>
                    </div>

                    <div className="control-group m0 mb pLarge">
                        <div className="ws-12 mbl">
                            <label className="ws-2 control-label  mrl prl mtl text-bold" >Format:</label>

                            <div className="ws-1 mtl">
                                <label className="ml" >
                                    xlsx
                                    <input type="radio" value="xlsx" className="m0" checked={fileFormat === "xlsx"} name="fileFormat" onClick={() => setfileFormat("xlsx")} />
                                </label>

                            </div>
                            <div className="ws-1 mtl">
                                <label className="ml" >
                                    csv
                                    <input type="radio" value="csv" className="m0" checked={fileFormat === "csv"} name="fileFormat" onClick={() => setfileFormat("xlsx")} />
                                </label>

                            </div>
                        </div>

                        <div className="ws-12 m0 mb">
                            <label className="ws-3 control-label  mrl prl mtl text-bold" >Number of rows:</label>

                            <div className="ws-5 mts">
                                <input type="number" name="numRows" value={rowCount} min="100" max="1048575" required className="ws-12" />
                            </div>

                        </div>

                        <div className="ws-12 m0">
                            <label className="ws-3 control-label  mrl prl mtl text-bold" >File Name:</label>

                            <div className="ws-5 mts">
                                <input type="text" name="fileName" value={fileName} onChange={(e: any) => setfileName(e.target.value)} maxLength={30} className="ws-12" />
                            </div>
                        </div>

                        <div className="ws-12 m0">
                            {(rowCount > 1048575 || 1048575 < 100) && <span className="alert alert-danger mt">Number of rows must be between 100 - 1048575</span>}
                            <label className="ws-12 control-label danger  mrl prl mtl text-bold">Number of rows must be between 100 - 1048575</label>

                        </div>

                    </div>

                    <div className="box-footer">
                        <button className="icon-btn close width100 height35" onClick={() => returnValue(1)} > Export</button>
                    </div>

                </div>
            </Modal>

        </div >
    )
}